<template>
    <v-card elevation="0" rounded="0" :loading="isBusy">
        <v-card-text>
            <create-bulk-order-import-statistics :import-id="importId" ref="statistics"/>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="onConfirm" color="primary" :loading="isBusy" block dark>
                {{ $t('bulk_orders_import.confirm') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import {API} from "@/api/api";
import snackbarMixin from "@/mixins/SnackbarMixin.vue";
import CreateBulkOrderImportStatistics from "@/components/user/bulkOrdersImport/CreateBulkOrderImportStatistics.vue";

export default {
    name: "CreateBulkOrderImportSummary",
    components: {CreateBulkOrderImportStatistics},
    mixins: [snackbarMixin],
    props: {
        importId: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        // loading
        isBusyImport: true, // true by default
        isBusyConfirm: false,
        // polling
        intervalId: null,
    }),
    computed: {
        isBusy() {
            return this.isBusyImport || this.isBusyConfirm;
        }
    },
    methods: {
        checkImport() {
            API.get("/api/bulk-order-imports/" + this.importId + "?refresh=true")
                .then(response => {
                    if (["dry-run-finished", "dry-run-failed"].includes(response.data.status)) {
                        clearInterval(this.intervalId);
                        this.isBusyImport = false;
                    }
                    this.$refs['statistics'].onFetchImport();

                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    // do nothing
                })
        },
        onConfirm() {
            this.isBusyConfirm = true;
            API.post("/api/bulk-order-imports/" + this.importId + "/process")
                .then(() => {
                    this.$emit("onConfirm");
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyConfirm = false;
                });
        }
    },
    created() {
        this.intervalId = setInterval(() => {
            this.checkImport();
        }, 3000);
    }
}
</script>
